export const Stack = {}

export default Stack
